import Vue from 'vue'
import Vuex from 'vuex'
import vMethod from './vMethod'
import gcyj from './gcyj'
import zxxx from './zxxx'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    vMethod,
    gcyj,
    zxxx,
  },
})
